import { configureStore } from '@reduxjs/toolkit';
import counterReducer from './counterSlice';
import cookieReducer from './cookieSlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    cookie: cookieReducer
  }
});

// 在客户端初始化时调用
if (typeof window !== 'undefined') {
  store.dispatch({ type: 'cookie/initializeCookieState' });
}

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
